import { ComponentIds, HierarchyUtils } from '@inter-ikea-core/core';
import ProductInfoComponent from '../components/ProductInfoComponent';
import { PlannerEcsSystem } from './System';
export class DebugSystem extends PlannerEcsSystem {
    constructor(coreApi) {
        super(coreApi, 'DebugSystem', ComponentIds.CLICK_EVENT_COMPONENT_ID);
    }
    onAdd(e) {
        const entity = HierarchyUtils.findWithComponentInUpwardsHierarchy(e, ComponentIds.SELECTABLE_COMPONENT_ID);
        if (!entity) {
            /* eslint-disable  no-console */
            console.error('Unable to find product root', e);
            return;
        }
        console.groupCollapsed(`%c ${entity.id}`, 'color: gray; font-weight: lighter;');
        const productInfo = entity.getComponent(ProductInfoComponent.id);
        console.groupCollapsed('Product info');
        console.log(`ProductName: \t${productInfo?.productName}`);
        console.log(`ArticleNumber: \t${productInfo?.globalArticleNbr}`);
        console.log(`ProductType: \t${productInfo?.productType}`);
        console.groupEnd();
        console.groupCollapsed('Entity');
        console.log(entity);
        console.groupEnd();
        console.groupCollapsed('Components');
        console.log(entity.components());
        console.groupEnd();
        console.groupCollapsed('Hierarchy');
        console.log({
            ancestors: this.entityListToMap(HierarchyUtils.getAncestors(entity)),
            decendants: this.entityListToMap(HierarchyUtils.hierarchy(entity).filter(f => f.id !== entity.id))
        });
        console.groupEnd();
        console.groupEnd();
        /* eslint-enable  no-console */
    }
    onUpdate() { }
    onRemove() { }
    entityListToMap(list) {
        return list.reduce((acc, curr, i) => {
            const displayname = curr.getComponent(ComponentIds.DISPLAY_NAME_COMPONENT_ID)?.name;
            if (!displayname)
                return acc;
            return {
                ...acc,
                [`${displayname}-${i}`.trim()]: curr
            };
        }, {});
    }
}
//# sourceMappingURL=DebugSystem.js.map